/**
 * VIP Ogledala - countdown "ВРЕМЕ ДО КРАЯ НА КАМПАНИЯТА"
 * Глобален 72-часов цикъл, изчислен от фиксирана UTC котва
 * (data-anchor, секунди от epoch) + дължина на цикъла (data-cycle,
 * секунди) - вижте snippets/vip-campaign-countdown.liquid.
 *
 * Формула: оставащо = цикъл − ((сега − котва) mod цикъл)
 * Изчислява се локално от Date.now() при всяко "тиктакане" - НЕ чете
 * localStorage/cookie и не пази собствено състояние, затова винаги е в
 * синхрон с Liquid снимката при зареждане и с всички други посетители.
 */
(function () {
  "use strict";

  function pad(value) {
    return value < 10 ? "0" + value : String(value);
  }

  function updateInstance(root) {
    var anchor = parseInt(root.getAttribute("data-anchor"), 10);
    var cycle = parseInt(root.getAttribute("data-cycle"), 10);

    if (!anchor || !cycle) {
      return;
    }

    var hoursEl = root.querySelector("[data-vip-countdown-hours]");
    var minutesEl = root.querySelector("[data-vip-countdown-minutes]");
    var secondsEl = root.querySelector("[data-vip-countdown-seconds]");

    if (!hoursEl || !minutesEl || !secondsEl) {
      return;
    }

    function tick() {
      var nowSeconds = Math.floor(Date.now() / 1000);
      var elapsed = nowSeconds - anchor;
      var intoCycle = ((elapsed % cycle) + cycle) % cycle;
      var remaining = cycle - intoCycle;

      if (remaining >= cycle) {
        remaining = 0;
      }

      var h = Math.floor(remaining / 3600);
      var m = Math.floor((remaining % 3600) / 60);
      var s = remaining % 60;

      hoursEl.textContent = pad(h);
      minutesEl.textContent = pad(m);
      secondsEl.textContent = pad(s);
    }

    tick();
    setInterval(tick, 1000);
  }

  function init() {
    var instances = document.querySelectorAll("[data-vip-countdown]");
    for (var i = 0; i < instances.length; i++) {
      updateInstance(instances[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
